












































import { Component, Vue, Prop } from "vue-property-decorator";
import { IterObatItem, RiwayatIterItem } from "@/types/riwayat";

@Component
export default class CardDetailIterObat extends Vue {
  @Prop({ required: true }) iter: RiwayatIterItem;

  get jumlahResep(): number {
    return this.iter.obat.length + this.iter.racikan.length;
  }

  jumlah(obat: IterObatItem): string {
    const qty = Number(obat.qty).toLocaleString("id-ID", { maximumFractionDigits: 2 });

    return obat.satuan ? `${qty} ${obat.satuan}` : qty;
  }
}
